/**
 * Include your custom JavaScript here.
 * 
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
// add to cart event
function addToCart(variant_id, handle, variant) {
  data = {
    "id": variant_id,
    "quantity": 1
  }
  $.ajax({
    type: 'POST',
    url: "".concat(window.routes.cartAddUrl, ".js"),
    data: data,
    dataType: 'json',
    error: function () {
      $( "#error_addtocart" ).show().delay(3000).fadeOut();
    },
    success: function () {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
      
      $.ajax({
        url: location.origin + '/products/' + handle + '.json',
        success: function(data) {
          addCartCollection(data.product, variant);
        }
      });
      
    },
  });
};

// blog scroll
$(document).ready(function() {
  /* klaviyo change status button */
  $('.ProductForm__BuyButtons').on('load DOMSubtreeModified', function(){
    var attr = $('.ProductForm__AddToCart').attr('disabled');
    if ($( ".ProductForm__AddToCart" ).hasClass( "Button--secondary" )){
      if (typeof attr !== typeof undefined && attr !== false) {
        $( "#KlaviyoButton" ).show();
        $( ".ProductForm__AddToCart" ).hide();
      } else {
        $( ".ProductForm__AddToCart" ).show();
        $( "#KlaviyoButton" ).hide();
      }
    } else {
      $( ".ProductForm__AddToCart" ).show();
      $( "#KlaviyoButton" ).hide();
    }
  });

  /* klaviyo mini */
  let url = new URL(window.location.href);
  if (url.searchParams.get('popup-mini')) {
    window._klOnsite = window._klOnsite || []; 
    window._klOnsite.push(['openForm', 'TvuFHr']);
  }
  
  //parallax scroll
  $(window).on("load scroll", function() {
    if($( window ).width() > 1007) {
      var parallaxElement = $(".ArticleList .Grid__Cell").filter(":nth-child(3n+1), :nth-child(3n+3)"),
          parallaxQuantity = parallaxElement.length;
    } else {
      var parallaxElement = $(".ArticleList .Grid__Cell:nth-child(2n+1)"),
          parallaxQuantity = parallaxElement.length;
    }
    
    window.requestAnimationFrame(function() {
      for (var i = 0; i < parallaxQuantity; i++) {
        var currentElement = parallaxElement.eq(i),
            windowTop = $(window).scrollTop(),
            //elementTop = currentElement.offset().top,
            elementHeight = currentElement.height(),
            viewPortHeight = window.innerHeight * 0.5 - elementHeight * 0.5,
            scrolled = windowTop + viewPortHeight;
            if($( window ).width() > 1007) {
              currentElement.css({
                transform: "translate3d(0," + scrolled * -0.3 + "px, 0)"
              });
            } else {
              currentElement.css({
                transform: "translate3d(0," + scrolled * -0.2 + "px, 0)"
              });
            }
      }
    });
  });

  $("[data-submenu-parent]").on('click', function(event) {
    let submenu = $(this).next();
    let icon = $(this).children().children(".open-submenu").children();
    event.preventDefault();
    if (submenu.css('display') == 'none') {
      submenu.css("display", "block");
      icon.css({
        "-webkit-transform": "rotate(180deg)",
        "-moz-transform": "rotate(180deg)",
        "transform": "rotate(180deg)"
      });
    } else {
      submenu.css("display", "none");
      icon.css({
        "-webkit-transform": "rotate(360deg)",
        "-moz-transform": "rotate(360deg)",
        "transform": "rotate(360deg)"
      });
    }
  });

  if($('.template-index #main').length){
    var timeout = null;
    $('.template-index #main').on('mousemove', function() {
        if (timeout !== null) {
            $("#fp-nav").removeClass('opacity');
            clearTimeout(timeout);
        }
    
        timeout = setTimeout(function() {
            if ( $("#fp-nav:hover").length <= 0 ) {
              $("#fp-nav").addClass('opacity');
            }
        }, 800);
    });
  }
  
});

/*
if($('.template-index #main').length){
  new fullpage('.template-index #main', {
    sectionSelector: '.shopify-section',
    navigation: true,
    navigationPosition: 'left',
    autoScrolling:true,
    lazyLoading: false,
    verticalCentered:false,
    scrollOverflow:true,
    scrollHorizontally: true,
    normalScrollElements: '.SliceFlex',
    licenseKey: '96NK9-CU0PK-AJH18-MPEJI-LZRRL',
    afterLoad: function(origin, destination, direction, trigger){
      var headerStyle = destination.item.firstChild.dataset.headerColor;
      if(headerStyle=="light") {
        $(".Header--transparent").addClass("light");
      } else {
        $(".Header--transparent").removeClass("light");
      }
    },
    onLeave: function(origin, destination, direction, trigger){
      var headerStyle = destination.item.firstChild.dataset.headerColor;
      if(headerStyle=="light") {
        $(".Header--transparent").addClass("light");
      } else {
        $(".Header--transparent").removeClass("light");
      }
    }
  });
  
  let start = null;
  const element = document.getElementById("section-template--14365162864686__166201595959014844");
  element.addEventListener('touchstart', function(e) {
      start = e.changedTouches[0];
  });
  
  $(document).ready(function(){
    $('#section-template--14365162864686__166201595959014844 .SliceFlex').bind('mousewheel', function(e){
      if(e.originalEvent.wheelDelta /120 > 0) {
        fullpage_api.moveSectionUp();
      }
      else{
        fullpage_api.moveSectionDown();
      }
    });
  });
  
  element.addEventListener('touchend', function(e) {
    let end = e.changedTouches[0];
    
    if(end.screenY - start.screenY > 40)
    {
      fullpage_api.moveSectionUp();
    }
    else if(end.screenY - start.screenY < -40)
    {
      fullpage_api.moveSectionDown();
    }
  });
}
*/


$(document).ready(function () {
  /*
    function timermaker() {
      var endTime = new Date(Date.UTC(2023, 0, 15, 22, 59, 59));
      
      //var endTime = new Date();
      //endTime.setHours(23,59,59);
      
      endTime = (Date.parse(endTime) / 1000);
      
      var now = new Date();
      now = (Date.parse(now) / 1000);
  
      var timeLeft = endTime - now;
      var days = Math.floor(timeLeft / 86400); 
      var hours = (Math.floor((timeLeft - (days * 86400)) / 3600)) + (24 * days);
      var hoursAux = Math.floor((timeLeft - (days * 86400)) / 3600);
      var minutes = Math.floor((timeLeft - (days * 86400) - (hoursAux * 3600 )) / 60);
      var seconds = Math.floor((timeLeft - (days * 86400) - (hoursAux * 3600) - (minutes * 60)));
  
      if (days < "10") { days = "0" + days; }
      if (hours < "10") { hours = "0" + hours; }
      if (minutes < "10") { minutes = "0" + minutes; }
      if (seconds < "10") { seconds = "0" + seconds; }
      $("div:not(#AnnouncementCountdown) > .days").html(days + "<span>:</span>");
      $("div:not(#AnnouncementCountdown) > .hours").html(hours + "<span>:</span>");
      $("div:not(#AnnouncementCountdown) > .minutes").html(minutes + "<span>:</span>");
      $("div:not(#AnnouncementCountdown) > .seconds").html(seconds);    
    }
    setInterval(function() { timermaker(); }, 1000);
  */
  /* ANNOUNCEMENT */
  function timermakerAnnouncement() {
    //var endTime = new Date(Date.UTC(2022,10,06,7,00,00,00));
    //endTime.setUTCHours(7,00,00,000);
    var endTime = new Date();
    endTime.setHours(23,59,59);
    endTime = (Date.parse(endTime) / 1000);

    var now = new Date();
    now = (Date.parse(now) / 1000);

    var timeLeft = endTime - now;
    var days = Math.floor(timeLeft / 86400); 
    var hours = Math.floor((timeLeft - (days * 86400)) / 3600);
    var minutes = Math.floor((timeLeft - (days * 86400) - (hours * 3600 )) / 60);
    var seconds = Math.floor((timeLeft - (days * 86400) - (hours * 3600) - (minutes * 60)));

    if (hours < "10") { hours = "0" + hours; }
    if (minutes < "10") { minutes = "0" + minutes; }
    if (seconds < "10") { seconds = "0" + seconds; }
    //$("#AnnouncementCountdown .days").html(days + "<span>Days</span>");
    $("#AnnouncementCountdown .hours").html(hours + "<span>:</span>");
    $("#AnnouncementCountdown .minutes").html(minutes + "<span>:</span>");
    $("#AnnouncementCountdown .seconds").html(seconds);
  }
  setInterval(function() { timermakerAnnouncement(); }, 1000);

  /*
  $('#section-header .HorizontalList__Item:first-child .MegaMenu__Item:not(:first-child)').hide();

  $('#section-header .HorizontalList__Item:first-child .MegaMenu__Item:first-child .Linklist__Item:not(:first-child):not(:nth-child(2))').hover(function() {
    $('#section-header .HorizontalList__Item:first-child .MegaMenu__Item:not(:first-child)').hide();
  });

  $('#section-header .HorizontalList__Item:first-child .MegaMenu__Item:first-child .Linklist__Item:first-child').hover(function() {
    $('#section-header .HorizontalList__Item:first-child .MegaMenu__Item:not(:first-child)').hide();
    $('#section-header .HorizontalList__Item:first-child .MegaMenu__Item:nth-child(2)').show();
  });
  
  $('#section-header .HorizontalList__Item:first-child .MegaMenu__Item:first-child .Linklist__Item:nth-child(2)').hover(function() {
    $('#section-header .HorizontalList__Item:first-child .MegaMenu__Item:not(:first-child)').hide();
    $('#section-header .HorizontalList__Item:first-child .MegaMenu__Item:nth-child(3)').show();
  });
 */

});